import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeFilters } from 'actions/search';
import { Link } from 'react-router-dom';
import districts from 'constants/Districts';
import { getHighlightedText } from '../utils';

import s from '../style';
import { hasRegionsInside } from '../../helpers';

@connect(null, { changeFilters })
export default class Regions extends Component {
  onItemClick = (ids) => {
    this.props.changeFilters({ subregion: ids });
    this.props.closeModal();
  }

  render() {
    const {
      name,
      items,
      isShown,
      highlight
    } = this.props;

    if (isShown && items.length && hasRegionsInside(items)) {
      return (
        <div className={s.resultSection}>
          <div className={s.resultSectionTitle}>{name} ({items.length})</div>
          {items.map((item) => {
            if (!districts[item.id - 1]) {
              return null;
            }

            const ids = Object.keys(districts[item.id - 1].checkboxes);
            return (
              <Link
                to={`/?subregion=${ids.join(',')}`}
                key={item.id}
                className={s.resultItemRegion}
              >
                <div onClick={() => this.onItemClick(ids)} className={s.resultItemTitleRegion}>
                  {getHighlightedText(item.name, highlight)}
                </div>
              </Link>
            );
          })}
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/Regions/Regions.js